module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_EL-2901a53d47c233ce9d16e2ae242130eb.svg";